"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnouncementTransport = exports.AnnouncementTypeLabels = exports.AnnouncementType = exports.AnnouncementTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
/**
 * An array of announcement type.
 */
exports.AnnouncementTypes = ['GENERAL', 'FEATURE_RELEASE', 'MAINTENANCE'];
/**
 * Represents a union of all announcement types.
 */
exports.AnnouncementType = typebox_1.Type.Union(exports.AnnouncementTypes.map((type) => typebox_1.Type.Literal(type)));
/**
 * A record that maps each announcement type to its label.
 */
exports.AnnouncementTypeLabels = {
    GENERAL: 'General',
    FEATURE_RELEASE: 'Feature Release',
    MAINTENANCE: 'Maintenance',
};
exports.AnnouncementTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    type: exports.AnnouncementType,
    title: typebox_1.Type.String(),
    description: typebox_1.Type.Optional(typebox_1.Type.String()),
    callToActionLink: typebox_1.Type.Optional(typebox_1.Type.String()),
    showAfter: typebox_1.Type.String({ format: 'date-time' }),
    showUntil: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    metadata: common_1.MetaData,
});
//# sourceMappingURL=announcement-transport.js.map